var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa fa-list",attrs:{"aria-hidden":"true"},on:{"click":_vm.setShowNav}})
}
var staticRenderFns = []

export { render, staticRenderFns }